<template>
	<footer
		class="footer"
		:class="{[`footer-${type}`]: type}"
		:data-background-color="backgroundColor"
	>
		<md-card-actions class="text-center" style="justify-content: center">
			<md-button href="https://www.linkedin.com/in/tan-daryl/"
			target="_blank" class="md-just-icon md-simple">
				<i class="fab fa-linkedin" style="font-size: 28px !important"></i>
			</md-button>
			<md-button href="https://github.com/daryl-tan" 
			target="_blank" class="md-just-icon md-simple">
				<i class="fab fa-github" style="font-size: 28px !important"></i>
			</md-button>
		</md-card-actions>
	</footer>
</template>
<script>
export default {
	props: {
		backgroundColor: String,
		type: String,
	},
};
</script>
<style></style>
